import styled from 'styled-components';

const Label = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: var(--input-label-color);
`;

export default Label;
